import React, { useState } from 'react';
import { apiService } from '@/services/api';

// Dead-end step for states the program doesn't serve yet (Luma's HI/AK
// pattern). Captures an email for launch updates; there is no Continue.
//   question.question / subtitle — copy
//   state    — the 2-letter code the patient picked
//   onJoined — optional; called after a successful signup (e.g. clear progress)
const WaitlistStep = ({ question, state, onJoined }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | done | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { setError('Please enter a valid email address'); return; }
    setError('');
    setStatus('sending');
    try {
      await apiService.joinAdvancedPeptideWaitlist({ email: email.trim(), state });
      setStatus('done');
      if (onJoined) onJoined();
    } catch (err) {
      setStatus('error');
      setError("We couldn't save your email right now. Please try again.");
    }
  };

  return (
    <div data-testid={`step-${question.id}`}>
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">{question.question}</h2>
      {question.subtitle && <p className="text-center text-gray-500 mb-8">{question.subtitle}</p>}
      {status === 'done' ? (
        <div className="max-w-md mx-auto rounded-2xl border border-gray-200 p-6 text-center" data-testid="waitlist-done">
          <p className="text-lg font-semibold text-gray-900 mb-1">You're on the list.</p>
          <p className="text-sm text-gray-500">We'll email you as soon as we launch in {state || 'your state'}.</p>
        </div>
      ) : (
        <form onSubmit={submit} noValidate className="max-w-md mx-auto space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="waitlist-email">Email address</label>
            <input
              id="waitlist-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              className={`form-input ${error ? 'error' : ''}`}
              data-testid="waitlist-email"
            />
            {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
          </div>
          <button type="submit" className="btn-primary" disabled={status === 'sending'} data-testid="waitlist-submit">
            {status === 'sending' ? 'Joining…' : 'Join the waitlist'}
          </button>
        </form>
      )}
    </div>
  );
};

export default WaitlistStep;
